import React, { createContext, useEffect } from "react";
import { SocketService, socketService } from "./socketService";
import { useAppSelector } from "@/stores/hook";
import { isDetachedPage } from "@/lib/detachedPage";

export const SocketContext = createContext<SocketService>(socketService);

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const token = useAppSelector((state) => state.auth.token);

  useEffect(() => {
    // A page outside the CRM (the live board) stays off the socket — see detachedPage.ts.
    if (token && !isDetachedPage()) {
      socketService.connect(token);
    } else {
      socketService.disconnect();
    }

    return () => {
      // Cleanup on full app unmount (rare, but good practice)
      socketService.disconnect();
    };
  }, [token]);

  return (
    <SocketContext.Provider value={socketService}>
      {children}
    </SocketContext.Provider>
  );
};
